import { useState } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetCustomerServices } from 'core/Store/customerServices/actions';
import { Service } from 'core/types/service';

export default function useCustomerServicesImport(customerId: number) {
  const showErrorNotification = useErrorNotifications();
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useSubstate(() => null);

  const importServices = (file: File) => {
    setLoading(true);

    const formData = new FormData();
    formData.append('services', file);

    return client()
      .post<Array<Service & { pivot: { price: number } }>>(
        `customers/${customerId}/services/import`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      .then((response) => response.data)
      .then((services) =>
        dispatch(new SetCustomerServices(customerId, services))
      )
      .catch((error) => {
        showErrorNotification(error);
        throw error;
      })
      .finally(() => setLoading(false));
  };

  return { importServices, loading };
}
